import { createCRUDService, fetchDropdowns } from './createCRUDService';
import { SUPPLIERS, DROPDOWNS } from './api/endpoints';

// Create base CRUD service
const baseCRUD = createCRUDService(SUPPLIERS.BASE);

// Export service with additional custom methods
export const SupplierService = {
  ...baseCRUD,

  // Get all dropdowns
  Alldropdowns: () => fetchDropdowns(DROPDOWNS.BASE),
  getStatuses: () => fetchDropdowns(DROPDOWNS.SUPPLIER_STATUS),
  getRatings: () => fetchDropdowns(DROPDOWNS.SUPPLIER_RATINGS),
  getPaymentTerms: () => fetchDropdowns(DROPDOWNS.PAYMENT_TERMS),
  getAccountTypes: () => fetchDropdowns(DROPDOWNS.ACCOUNT_TYPES),
};

export default SupplierService;
